// src/components/Testimonials.jsx
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "bootstrap-icons/font/bootstrap-icons.css"; // if you're using Bootstrap Icons
import "./Testmonial.css"; // Assuming you have a CSS file for styling
const testimonials = [
  {
    name: "Rohit Goswami ",
    role: "Restaurant ",
    image: "../assets/team-1.jpeg",
    text: "Love the food ordering experience on this app! The delivery is always on time and the food is delicious.",
    
  },
  {
    name: "Naresh Kumar",
    role: "Customer",
    image: "../assets/team2.jpeg",
    text: "Best food delivery app ever! The UI is so user-friendly and the discounts are amazing.",

    



  },
  {
    name: "Mr Lorick ",
    role: "Customer",
    image: "../assets/lorick.jpg",
    text: "Food ordering made easy! The app is super fast and reliable.",
  },
  {

    
    name: "Mukesh Jangra",
    role: "Customer",
    image: "../assets/muk.jpeg",
    text: "Great selection of restaurants and dishes. Delivery is always prompt!",
  },
  {
    name: "Shubham Dhiman",
    role: "Customer ",
    image: "../assets/shub.jpeg",
    text: "Food ordering made easy! The app is super fast and reliable....",
  },
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="testimonials section ">
      <div className="container" data-aos="fade-up">
        <h1 className="text-center p-3">Testimonials</h1>
        {/* <p>Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p> */}
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <Swiper
          modules={[Autoplay, Pagination]}
          loop={true}
          speed={600}
          autoplay={{ delay: 5000 }}
          pagination={{ clickable: true }}
          breakpoints={{
            320: { slidesPerView: 1, spaceBetween: 40 },
            1200: { slidesPerView: 3, spaceBetween: 1 },
          }}
        >
          {testimonials.map((t, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-item">
                 <div className="profile mt-auto">
                  <img src={t.image} className="testimonial-img" alt={t.name} />
                  <h3>{t.name}</h3>
                  <h4>{t.role}</h4>
                </div>
                <div className="stars">
                  {[...Array(5)].map((_, i) => (
                    <i className="bi bi-star-fill" key={i}></i>
                  ))}
                </div>
                <p>{t.text}</p>
               
              </div>
            </SwiperSlide>
          ))}
          <div className="swiper-pagination"></div>
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonials;
